import React from 'react'

import {
  Button,
  Modal,
  ModalInjectedProps,
  useModalContext,
} from '@sketch/components'
import { ContinueWithApple } from '@sketch/modules-common'

import AreYouSureModal from '../AreYouSureModal'

const SocialDeleteAccountModal = ({ hideModal }: ModalInjectedProps) => {
  const { showModal } = useModalContext()

  const handleAppleSignIn = () => {
    showModal(AreYouSureModal, {
      provider: 'APPLE',
    })
  }

  return (
    <Modal title="Delete Your Account and All Documents?" onCancel={hideModal}>
      <Modal.Body>
        <p>
          Deleting your account will also delete all documents you may have
          shared. You can&apos;t undo this action.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Cancel
        </Button>
        <ContinueWithApple
          showIconOnly={false}
          onClick={handleAppleSignIn}
          loading={false}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default SocialDeleteAccountModal
